import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const curiosity: BlogMetaData = {
  title: '子どもの好奇心を伸ばす家庭環境チェック10｜モンテッソーリ流の声かけ実例',
  description:
    '子どもの好奇心を家庭で伸ばす環境づくりチェック10項目と、OK/NGの声かけ実例、今すぐできる3分リセットをモンテッソーリ視点で具体的に解説します。',
  thumbnailUrl: '/img/blog-curiosity-thumbnail.webp',
  filePath: buildBlogFilePath('curiosity'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
